<template>
    <section class="section sec1">
        <div class="inner">
            <div class="txtbox">
                <img :src="`${$STATIC_URL}/user/img/logo_w.png`" alt="" class="logo">
                <p class="txt1">
                    로또 번호를 정확하게 맞춘다고 광고하는 것은 <br>
                    100% 거짓말이죠! 하지만 DATA Analysis와 AI 기술을 <br>
                    사용하여 당첨확률을 높이는 것은 가능한 일입니다.
                </p>
                <p class="txt2">
                    지금 바로 무료로 사용해보세요!
                </p>
            </div>
            <div class="btnbox">
                <button type="button" class="btn" id="spin_button" @click="startGame">시작하기</button>
            </div>
            <div class="jackpotbox">
                <div class="jackpot_item">
                    <div class="slot_title">1st</div>
                    <div class="slot_box"
                        :class="num1 < 10 ? 'color1' : num1 >= 10 && num1 < 20 ? 'color2' : num1 >= 20 && num1 < 30 ? 'color3' : num1 >= 30 && num1 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot1">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num1 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jackpot_item">
                    <div class="slot_title">2nd</div>
                    <div class="slot_box"
                        :class="num2 < 10 ? 'color1' : num2 >= 10 && num2 < 20 ? 'color2' : num2 >= 20 && num2 < 30 ? 'color3' : num2 >= 30 && num2 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot2">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num2 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jackpot_item">
                    <div class="slot_title">3rd</div>
                    <div class="slot_box"
                        :class="num3 < 10 ? 'color1' : num3 >= 10 && num3 < 20 ? 'color2' : num3 >= 20 && num3 < 30 ? 'color3' : num3 >= 30 && num3 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot3">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num3 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jackpot_item">
                    <div class="slot_title">4th</div>
                    <div class="slot_box"
                        :class="num4 < 10 ? 'color1' : num4 >= 10 && num4 < 20 ? 'color2' : num4 >= 20 && num4 < 30 ? 'color3' : num4 >= 30 && num4 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot4">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num4 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jackpot_item">
                    <div class="slot_title">5th</div>
                    <div class="slot_box"
                        :class="num5 < 10 ? 'color1' : num5 >= 10 && num5 < 20 ? 'color2' : num5 >= 20 && num5 < 30 ? 'color3' : num5 >= 30 && num5 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot5">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num5 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jackpot_item">
                    <div class="slot_title">6th</div>
                    <div class="slot_box"
                        :class="num6 < 10 ? 'color1' : num6 >= 10 && num6 < 20 ? 'color2' : num6 >= 20 && num6 < 30 ? 'color3' : num6 >= 30 && num6 < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot6">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ num6 }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="winning_plus" :style="{background: `url(${$STATIC_URL}/user/img/ico_plus.png) no-repeat center / contain`}"></div> -->
                <!-- <div class="jackpot_item">
                    <div class="slot_title" style="padding-left: 2px;">bonus</div>
                    <div class="slot_box"
                        :class="bonus < 10 ? 'color1' : bonus >= 10 && bonus < 20 ? 'color2' : bonus >= 20 && bonus < 30 ? 'color3' : bonus >= 30 && bonus < 40 ? 'color4' : 'color5'">
                        <div class="swiper slot_swiper" id="slot6">
                            <div class="swiper-wrapper">
                                <div class="swiper-slide swiper-slide-active">{{ bonus }}</div>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </section>
</template>
<script setup>
import { useStore } from 'vuex';
import { getWinNum } from '@/api';
import { onMounted, ref } from 'vue';
const store = useStore();
const startGame = () => {
    store.commit('setUserInfoModalContent', '앱 설치 후 이용 가능합니다.');
}
const num1 = ref(1);
const num2 = ref(1);
const num3 = ref(1);
const num4 = ref(1);
const num5 = ref(1);
const num6 = ref(1);
const bonus = ref(1);
onMounted(async () => {
    const res = await getWinNum();
    num1.value = res.data.number.num_1;
    num2.value = res.data.number.num_2;
    num3.value = res.data.number.num_3;
    num4.value = res.data.number.num_4;
    num5.value = res.data.number.num_5;
    num6.value = res.data.number.num_6;
    bonus.value = res.data.number.bonus_num;
})


</script>